
import React, { useState } from 'react';

const RefinanceQuestionsSection: React.FC = () => {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);

  const questions = [
    {
      question: 'When is the best time to refinance?',
      answer: 'The best time to refinance is typically when interest rates drop by at least 0.5-1% below your current rate, when your credit score has improved significantly, or when you want to change your loan term. Market conditions and your financial situation both play important roles in timing.'
    },
    {
      question: 'How much equity do I need?',
      answer: 'Most lenders require at least 20% equity in your home to refinance, though some programs allow refinancing with as little as 5-10% equity. Having more equity typically results in better rates and terms, and eliminates the need for mortgage insurance.'
    },
    {
      question: 'What are the closing costs?',
      answer: 'Closing costs for refinancing typically range from 2-5% of the loan amount, including appraisal fees, title insurance, origination fees, and other processing costs. Many lenders offer no-closing-cost options where costs are rolled into the loan or offset by a slightly higher rate.'
    },
    {
      question: 'How long does the refinance process take?',
      answer: 'The refinancing process typically takes 30-45 days from application to closing. This includes time for document collection, property appraisal, underwriting review, and final approval. Having all documents ready can help speed up the process.'
    },
    {
      question: 'Will refinancing affect my credit score?',
      answer: 'Refinancing may cause a temporary small dip in your credit score due to the hard credit inquiry, but this typically recovers within a few months. The long-term impact is often positive if refinancing helps you manage payments better or pay down debt faster.'
    },
    {
      question: 'Can I refinance if I have bad credit?',
      answer: 'While having good credit helps secure better rates, refinancing with less-than-perfect credit is still possible. Government programs like FHA and VA loans have more flexible credit requirements, and some lenders specialize in working with borrowers with credit challenges.'
    }
  ];

  const toggleQuestion = (index: number) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Questions About Refinancing?
          </h2>
          <p className="text-xl text-gray-300">
            Get answers to the most common refinancing questions from our mortgage experts.
          </p>
        </div>

        <div className="space-y-4">
          {questions.map((item, index) => (
            <div 
              key={index}
              className="bg-gray-800 rounded-xl shadow-md overflow-hidden border border-gray-700"
            >
              <button
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-700 transition-colors duration-200 cursor-pointer"
                onClick={() => toggleQuestion(index)}
              >
                <h3 className="text-lg font-semibold text-white pr-8">
                  {item.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openQuestion === index ? 'subtract' : 'add'}-line text-red-600 text-xl transition-transform duration-200`}></i>
                </div>
              </button>
              
              {openQuestion === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-300 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RefinanceQuestionsSection;